import LanguageSlot from './src/main';

/* istanbul ignore next */
LanguageSlot.install = function(Vue) {
  Vue.component(LanguageSlot.name, LanguageSlot);
};

export default LanguageSlot;
